<div class="seds-checkbox">
  <div
    *ngIf="!checkFormTypeService.isReactiveForm(model, controlName)"
    class="check-wrapper"
    [ngClass]="[selectedColor]">
    <span>
      <mat-checkbox
        [attr.aria-label]="label"
        [checked]="allComplete"
        [disabled]="disabled"
        tabIndex="0"
        [labelPosition]="labelPosition"
        [(ngModel)]="model"
        [indeterminate]="updateIndeterminated()"
        [required]="required"
        (change)="updateChildren($event.checked)">
        {{ label }} <ng-content *ngIf="required">*</ng-content>
      </mat-checkbox>
    </span>
    <span *ngIf="items">
      <div *ngFor="let subItem of items">
        <mat-checkbox
          [(ngModel)]="subItem.checked"
          [attr.aria-label]="subItem.name"
          [labelPosition]="subItem.position"
          [disabled]="disabled"
          (ngModelChange)="update()">
          {{ subItem.name }}
        </mat-checkbox>
      </div>
    </span>
  </div>

  <div
    *ngIf="checkFormTypeService.isReactiveForm(model, controlName)"
    class="check-wrapper"
    [ngClass]="[selectedColor]">
    <span>
      <mat-checkbox
        [attr.aria-label]="label"
        [checked]="allComplete"
        [attr.disabled]="disabled"
        tabIndex="0"
        [labelPosition]="labelPosition"
        [formControl]="formControl"
        [indeterminate]="updateIndeterminated()"
        [required]="required"
        (change)="updateChildren($event.checked)">
        {{ label }} <ng-content *ngIf="required">*</ng-content>
      </mat-checkbox>
    </span>
    <span *ngIf="items">
      <div *ngFor="let subItem of items">
        <mat-checkbox
          [(ngModel)]="subItem.checked"
          [attr.aria-label]="subItem.name"
          (ngModelChange)="update()"
          [labelPosition]="subItem.position"
          [disabled]="disabled">
          {{ subItem.name }}
        </mat-checkbox>
      </div>
    </span>
  </div>
</div>
